<template>
   <div class="w-full"><button @click="selectingImage=true"><vue-feather type="plus" size="20px" /></button>
    <Images v-if="selectingImage" @image-selected="pickImage" @cancel="selectingImage=false" />
        <ul class="flex flex-wrap gap-2">

            <li v-for="i in images" :key="i.id" class="w-1/6">
                <div v-if="i.image_id" class="w-full h-36 text-xs" :style="`background: url('/storage/webp/${i.image?.filename}-320x120.webp') center center;background-repeat:no-repeat`">
                    <!-- <img :src="`/storage/images/${i.image?.filename}-320x120.${i.image?.extension}`" class="max-w-36 max-h-24 object-fit" alt="x"> -->
                    <ul class="flex flex-wrap w-full justify-between">
                        <li class="w-3/4 h-8 bg-black/60 p-2 overflow-hidden">{{ i.image?.title }}
                        </li>
                        <li class="w-1/4">
                            <input class="text-right w-full h-8 bg-slate-800 border border-slate-500 p-2" type="text" name="order" :value="i.order" :data-id="i.image_id" @keyup.enter="newOrder"/>
                        </li>
                        <li class="self-end" @click="removeImage(i.image_id)"><vue-feather type="trash" size="24px" /></li>
                        <li class="self-start`">
                            <Link :href="`/admin/image-editor?image=${i.image?.id}`">{{ i.image?.id }}</Link>
                        </li>
                        <!-- <li><textarea class="w-full h-24" v-model="i.image.caption"></textarea></li> -->
                        <!-- <li><textarea class="w-full h-24" v-model="i.image.description"></textarea></li> -->
                    </ul>
                </div>
                <span v-else>
                    {{ i }}
                </span>
            </li>
        </ul>
   </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3'
import Images from '@/components/Images.vue'
export default {
    name: "GaleryEditor",
    props: ['images', 'id'],
    components: { Link, Images },
    computed: {},
    data() {
       return {
            selectingImage:false
       }
    },
    mounted() {

    },
    methods: {
        newOrder(e) {
            router.post('/update-order', {objectType: 'GalleryImage ', objectID: this.id, childID: e.target.dataset.id, value: e.target.value});
            // api.post('update-order', {objectID: this.id, childID: e.target.dataset.id, value: e.target.value})
            // .then(d => {
            //     console.log(d);
            // })
        },
        addNewImage(imageID) {
            router.post('/add-image-to-gallery', {objectType: 'GalleryImage ', objectID: this.id, newImageID: imageID});
            this.selectingImage=false;
        },
        removeImage(imageID) {
            router.post('/remove-image-from-gallery', {objectType: 'GalleryImage ', objectID: this.id, ImageID: imageID});
        },
        pickImage(e) {
            this.addNewImage(e.id)
        }
    }
}
</script>
